import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api, API } from "@/lib/api";
import { useT, localized } from "@/i18n";

export const showcaseImg = (id, which) => `${API}/showcase/${id}/image/${which}`;

export function BeforeAfter({ before, after, labels, testId }) {
  const [pos, setPos] = useState(50);
  if (!before) return <img src={after} alt="" className="h-72 w-full rounded-3xl object-cover border border-craft" data-testid={testId} />;
  return (
    <div className="relative h-72 w-full overflow-hidden rounded-3xl border border-craft select-none" data-testid={testId}>
      <img src={after} alt={labels[1]} className="absolute inset-0 h-full w-full object-cover" />
      <img src={before} alt={labels[0]} className="absolute inset-0 h-full w-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
      <div className="absolute inset-y-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }} />
      <span className="absolute left-3 top-3 rounded-full bg-ink/70 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">{labels[0]}</span>
      <span className="absolute right-3 top-3 rounded-full bg-terracotta px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">{labels[1]}</span>
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} aria-label="before/after"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" data-testid={`${testId}-slider`} />
    </div>
  );
}

export function Showcase() {
  const { t, locale } = useT();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/showcase").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <section className="mt-28" data-testid="showcase-section">
      <p className="eyebrow">{t("showcase.eyebrow")}</p>
      <h2 className="mt-2 font-serif text-3xl sm:text-4xl font-semibold">{t("showcase.title")}</h2>
      <p className="mt-2 text-sm text-ink/55">{t("showcase.subtitle")}</p>
      <div className="mt-8 grid md:grid-cols-2 gap-8">
        {items.map((x) => (
          <article key={x.id} className="card-craft p-5 flex flex-col gap-4" data-testid={`showcase-item-${x.id}`}>
            <BeforeAfter before={x.before_file_id && showcaseImg(x.id, "before")} after={showcaseImg(x.id, "after")} labels={[t("showcase.before"), t("showcase.after")]} testId={`showcase-ba-${x.id}`} />
            <div>
              <h3 className="font-serif text-2xl font-semibold">{localized(x, "title", locale)}</h3>
              {x.city && <p className="text-xs text-ink/50 font-mono mt-0.5">{x.city}</p>}
              <blockquote className="mt-3 flex gap-3 text-sm text-ink/70 leading-relaxed"><Quote size={18} className="text-terracotta flex-none mt-0.5" /><span>{localized(x, "review_text", locale)}</span></blockquote>
              <p className="mt-2 text-xs font-semibold text-ink/60">— {x.review_author}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
